import { ResetPasswordBlock } from "@/admin/vm/ResetPasswordBlock.tsx";
import { vmQueryAtom } from "@/admin/vm/vmQuery.ts";
import { SecretKey } from "@/components/SecretKey.tsx";
import { ToolbarText } from "@/components/ToolbarText.tsx";
import { WVnc } from "@/modules/compute/WVnc.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import type { AdminVirtualMachine, VmResetPasswordResponse } from "@warrenio/api-spec/spec.oats.gen";
import { useState } from "react";

function Credentials({ vm, location }: { vm: AdminVirtualMachine; location: string }) {
    const [credentials, setCredentials] = useState<VmResetPasswordResponse>();
    return (
        <ToolbarText>
            Username:&nbsp;<b>{vm.username}</b>
            <div className="pl-3">
                Password:&nbsp;
                {credentials?.password ? (
                    <SecretKey value={credentials.password} visible />
                ) : (
                    <ResetPasswordBlock onChange={setCredentials} item={vm} location={location} />
                )}
            </div>
        </ToolbarText>
    );
}

export function Vnc({ vmId, location }: { vmId: string; location: string }) {
    const vm: AdminVirtualMachine = useSuspenseQueryAtom(vmQueryAtom(location, vmId));

    return <WVnc vm={vm} location={location} isAdmin toolbar={<Credentials vm={vm} location={location} />} />;
}
